/**
 * @generated SignedSource<<c2ef6319333174b49a6e3c7dfda38f60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailFramingOptions_refactor_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpSharedDetailFramingOptions_refactor_user";
};
export type PdpSharedDetailFramingOptions_refactor_user$key = {
  readonly " $data"?: PdpSharedDetailFramingOptions_refactor_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_refactor_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_refactor_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "635ada8d3181b4a4079f6b32689ae7c6";

export default node;
